import React from "react";
import EstimateWizardContainer from "./EstimateWizardContainer.tsx";
import EstimateFormComparison from "../../contracts/estimates/EstimateFormComparison.tsx";
import { COMPARISION_COMPANY_IN_CHARGE_TYPE, REMARK_MUN, EstimateDto } from "../../contracts/estimates/types.ts";
import { useEstimateApi } from "../../hooks/useEstimateApi.ts";

export default function EstimateWizardComparison() {
    const { previewContentPdfComparison } = useEstimateApi();

    return (
        <EstimateWizardContainer
            companyInChargeIndex={0}
            defaultValues={{
                companyInCharge: COMPARISION_COMPANY_IN_CHARGE_TYPE[0],
                content: {
                    remark: REMARK_MUN
                } as any
            }}
            stepsConfig={[
                {
                    label: "비교 견적서 본문",
                    render: (props) => <EstimateFormComparison {...props} />
                }
            ]}
            getPreviewBlob={async (data: EstimateDto, activeStep: number) => {
                if (!data.companyInCharge) {
                    throw new Error("회사를 선택하세요");
                }
                const content = await previewContentPdfComparison(data);
                return { content };
            }}
        />
    );
}
